export const refreshAds = (): void => {
  if (document && CustomEvent && typeof document.dispatchEvent === 'function') {
    document.dispatchEvent(new CustomEvent('DisplayAdRefresh'));
  }
};
